import type { Maybe, Warehouse } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

type FamilyParams = {
  familyEditionId: Maybe<string>
  familyTitle: Maybe<string>
  familyWarehouse: Maybe<Warehouse>
  warehouseId: Maybe<number>
  captchaRequired: boolean
}

export const useFamilyChoiceStore = defineStore('FamilyChoice', () => {
  const familyEditionId = ref<Maybe<string>>(null)
  const familyTitle = ref<Maybe<string>>(null)
  const familyWarehouse = ref<Maybe<Warehouse>>(null)
  const warehouseId = ref<Maybe<number>>(null)
  const captchaRequired = ref<boolean>(false)

  function setFamily({
    familyEditionId: newFamilyEditionId,
    familyTitle: newFamilyTitle,
    familyWarehouse: newFamilyWarehouse,
    warehouseId: newWarehouseId,
    captchaRequired: newCaptchaRequired
  }: FamilyParams) {
    familyEditionId.value = newFamilyEditionId
    familyTitle.value = newFamilyTitle
    familyWarehouse.value = newFamilyWarehouse
    warehouseId.value = newWarehouseId
    captchaRequired.value = newCaptchaRequired
  }

  return { familyEditionId, familyTitle, familyWarehouse, warehouseId, captchaRequired, setFamily }
})
